import { call, put, select, takeLatest } from 'typed-redux-saga'
import {
	leadApi,
	leadOneSlice,
	LeadsNS,
	leadsSelector,
	leadsSlice,
	leadUiSelector,
	ParamsMassUpdateLead,
	RbidosLeadModel,
	STATUSES_FOR_REQUEST_LEAD,
} from 'Pages/lead'
import { RequestParams, ResponseCatalog } from 'Models'
import { NOTIFICATION_TYPE, showNotificationAction, errorHandler, gridSlice } from 'Modules'

export function* getAll(action: LeadsNS.GetAll) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		const { page, per_page, query, ...fields } = params
		const agreementState = yield* select(leadUiSelector.selectAgreementState)
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, { ...fields })
		if (!fields.state && agreementState)
			requestParams.state = STATUSES_FOR_REQUEST_LEAD[agreementState].join()

		if (clear) {
			yield* put(leadsSlice.actions.clearAll())
		}
		const res = yield* call(leadApi.getAll, requestParams)
		const rbidosLeads = new ResponseCatalog<RbidosLeadModel>(res)
		if (!clear) {
			const oldRbidosLeads = yield* select(leadsSelector.selectEntries)
			rbidosLeads.entries = oldRbidosLeads.concat(res.entries)
		}

		yield* put(leadsSlice.actions.setAll(rbidosLeads))
		yield* put(leadsSlice.actions.setRequestParams(requestParams))
		if (rbidosLeads.entries.length) {
			yield* put(leadOneSlice.actions.setOne(rbidosLeads?.entries[0]))
		} else {
			yield* put(leadOneSlice.actions.setOne(null))
		}

		callback?.()
	} catch (error) {
		yield* put(
			showNotificationAction({
				type: NOTIFICATION_TYPE.ERROR,
				message: 'Ошибка при получении лидов',
				data: error?.data?.errors ?? [],
			})
		)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

export function* massUpdateLeadsIds(action: LeadsNS.MassUpdateLeadsIds) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const selectedLeadIds = yield* select(leadsSelector.getSelectedLeadIds)
		const rbidosLeads = yield* select(leadsSelector.selectEntries)
		const currentRequestParams = yield* select(leadsSelector.selectRequestParams)
		const { query } = currentRequestParams
		const params: ParamsMassUpdateLead =
			selectedLeadIds.length !== rbidosLeads.length || query
				? { id: selectedLeadIds, mass_update: false, filters: currentRequestParams }
				: { id: [], mass_update: true, filters: currentRequestParams }
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const res = yield* call(leadApi.massUpdateLeadsIds, params)
	} catch (error) {
		yield* put(
			showNotificationAction({
				type: NOTIFICATION_TYPE.ERROR,
				message: 'Ошибка при массовом обновлении лидов',
				data: error?.data?.errors ?? [],
			})
		)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

export function* socketMassUpdateLeadsIds(action: LeadsNS.SocketMassUpdateLeadsIds) {
	try {
		const requestParams = yield* select(leadsSelector.selectRequestParams)
		requestParams.page = 1
		yield* put(gridSlice.actions.setLoading(true))
		yield* put(leadsSlice.actions.clearAll())
		yield* put(leadsSlice.actions.clearLeadsIds())
		const res = yield* call(leadApi.getAll, requestParams)
		const rbidosLeads = new ResponseCatalog<RbidosLeadModel>(res)
		yield* put(leadsSlice.actions.setAll(rbidosLeads))
		yield* put(leadsSlice.actions.setRequestParams(requestParams))
		if (rbidosLeads.entries.length) {
			yield* put(leadOneSlice.actions.setOne(rbidosLeads?.entries[0]))
		} else {
			yield* put(leadOneSlice.actions.setOne(null))
		}
		yield* put(
			showNotificationAction({
				type: NOTIFICATION_TYPE.SUCCESS,
				message: 'Выбранные согласия обновлены',
				data: [],
			})
		)
	} catch (error) {
		yield* put(
			showNotificationAction({
				type: NOTIFICATION_TYPE.ERROR,
				message: 'Ошибка при массовом обновлении лидов из сокетов',
				data: error?.data?.errors ?? [],
			})
		)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* massUpdateLeadsFile(action: LeadsNS.MassUpdateLeadsFile) {
	try {
		yield* call(leadApi.massUpdateLeadsFile, { file: action.payload })
		yield* put(
			showNotificationAction({
				type: NOTIFICATION_TYPE.SUCCESS,
				message: 'Файл изменения статусов ушел на обработку',
				data: [],
			})
		)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* leadsSaga() {
	yield* takeLatest(leadsSlice.actions.getAll.type, getAll)
	yield* takeLatest(leadsSlice.actions.massUpdateLeadsIds.type, massUpdateLeadsIds)
	yield* takeLatest(leadsSlice.actions.socketMassUpdateLeadsIds.type, socketMassUpdateLeadsIds)
	yield* takeLatest(leadsSlice.actions.massUpdateLeadsFile.type, massUpdateLeadsFile)
}
